import { FC } from 'react';
import classNames from 'classnames';
import NextLink from 'next/link';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { useServices } from '@whitesharx/starfall-frontend-core';
import { sounds } from '@whitesharx/starfall-frontend-ui-kit';
import {
  activeItemStyle,
  mobileAnalyzeButtonStyles,
  containerStyles,
  hiddenTabStyles,
  itemStyle,
  overflowStyles,
  tabsContainerStyles,
  desktopAnalyzeButtonStyles,
} from './styles.css';

import { ReviewTab } from '../ReviewTab';
import { AnalysisNavigationTab } from '../../types';
import { AnalysisTab } from '../AnalysisTab';
import { useAtom } from '@reatom/npm-react';
import { analyzeGameAction, gameAnalyzedAtom } from '../../model';
import AnalyzeButton from '../AnalyzeButton/AnalyzeButton';
import { contentPaddingStyles } from '../../styles.css';

const AnalysisTools: FC = () => {
  const { useRouter, useResponsive } = useServices();
  const { isDesktop } = useResponsive();
  const router = useRouter();

  const handleClick = () => {
    sounds.play('click');
  };

  const tab = (router.query.tab as AnalysisNavigationTab) || 'analysis';

  const [gameAnalyzed] = useAtom(gameAnalyzedAtom);
  const [analyzingStatus] = useAtom(analyzeGameAction.statusesAtom);
  const [analyzeGameController] = useAtom(analyzeGameAction.abortControllerAtom);

  const showAnalyzeButton = !(analyzingStatus.isPending && !analyzeGameController?.signal.aborted) && !gameAnalyzed;

  return (
    <>
      {!isDesktop && showAnalyzeButton && <AnalyzeButton className={mobileAnalyzeButtonStyles} />}

      <div className={containerStyles}>
        <div className={tabsContainerStyles}>
          <NextLink href={{ query: { ...router.query, tab: 'analysis' } }} passHref replace>
            <a className={classNames(itemStyle, { [activeItemStyle]: tab === 'analysis' })} onClick={handleClick}>
              {t('analysis.analysis-tab')}
            </a>
          </NextLink>
          <NextLink href={{ query: { ...router.query, tab: 'review' } }} passHref replace>
            <a className={classNames(itemStyle, { [activeItemStyle]: tab === 'review' })} onClick={handleClick}>
              {t('analysis.review-tab')}
            </a>
          </NextLink>
        </div>

        <AnalysisTab
          className={classNames(containerStyles, tab === 'analysis' ? '' : hiddenTabStyles, overflowStyles.hidden)}
          analyzeButton={
            isDesktop && showAnalyzeButton ? (
              <div className={contentPaddingStyles}>
                <AnalyzeButton className={desktopAnalyzeButtonStyles} />
              </div>
            ) : undefined
          }
        />

        <ReviewTab
          className={classNames(
            containerStyles,
            tab === 'review' ? '' : hiddenTabStyles,
            overflowStyles.auto,
            'scrollStyle'
          )}
          analyzeButton={
            isDesktop && showAnalyzeButton ? <AnalyzeButton className={desktopAnalyzeButtonStyles} /> : undefined
          }
        />
      </div>
    </>
  );
};

export default AnalysisTools;
